import * as React from 'react';

import classNames from 'classnames';
import moment from 'moment';

import {TextField} from 'shells/textfield/textfield';

import {DatePicker} from '../../../base/date-picker';

import styles from './form-date-picker.module.css';

type Props = {
    value: number;
    dateFormat: string;
    onChange: (newDate: number /* UNIX secs */) => any;
    isDisabled?: boolean;
    isLightMode?: boolean;
    isFullWidth?: boolean;
    shouldDisableFocusTrapZone?: boolean;
};

export function FormDatePicker(props: Props) {
    const {value = moment().unix(), dateFormat = 'D MMMM YYYY', isFullWidth = false} = props;

    const [openDatePicker, setOpenDatePicker] = React.useState<boolean>(false);
    const inputNode = React.useRef<HTMLElement | null | undefined>(null);
    const datePickerJustClosed = React.useRef<boolean>(false);

    const formattedDate = moment(value * 1000).format(dateFormat);

    const containerClasses = classNames(styles.container, {
        [styles['container--full-width']]: isFullWidth,
    });

    const handleSubmit = (date: moment.Moment) => {
        handleCloseDatePicker();
        const newValue = moment(date).unix();
        props.onChange(newValue);
    };

    const handleCloseDatePicker = () => {
        datePickerJustClosed.current = true;
        setOpenDatePicker(false);

        setTimeout(() => {
            datePickerJustClosed.current = false;
        }, 100);
    };

    return (
        <div className={containerClasses}>
            <TextField
                // @ts-expect-error
                readOnly={true}
                textFieldRef={(c) => {
                    inputNode.current = c;
                }}
                value={formattedDate}
                onFocus={() => {
                    if (!props.isDisabled && !datePickerJustClosed.current) {
                        setOpenDatePicker(true);
                    }
                }}
                onClick={() => {
                    if (!props.isDisabled) {
                        setOpenDatePicker(true);
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Tab') {
                        setOpenDatePicker(false);
                    }
                }}
                disabled={props.isDisabled}
            />
            {openDatePicker && !props.isDisabled && (
                <DatePicker
                    initialDate={moment.unix(value)}
                    // @ts-expect-error
                    anchor={inputNode.current}
                    location='bottom'
                    onSubmit={handleSubmit}
                    onCancel={handleCloseDatePicker}
                    onKeyDown={(e) => {
                        if (e.key === 'Tab') {
                            handleCloseDatePicker();
                        }
                    }}
                    isLightMode={props.isLightMode}
                    shouldDisableFocusTrapZone={props.shouldDisableFocusTrapZone}
                />
            )}
        </div>
    );
}
